import React from 'react';
import { connect } from 'react-redux'
import { setQuestionAnswer } from '../../api/health-questions/actions'
import { fetchNationalRegistry } from '../../api/national-registry/actions'
import { calculateAgeFromKennitala } from '../../utils';

const kennitala = require('kennitala')


class SsnLookup extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            search: '',
            error: '',
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.nationalRegistry.data.find(item => item.OrgId === kennitala.clean(prevState.search))) {
            let age = calculateAgeFromKennitala(kennitala.clean(prevState.search))
            if (age > 17) {
                return { lookupObj: nextProps.nationalRegistry.data.find(item => item.OrgId === kennitala.clean(prevState.search)) };
            } else {
                return { lookupObj: null}
            }
        }
        else return null;
    }

    componentDidMount() {
        initialInputState();
    }

    componentDidUpdate(prevProps, prevState) {
        initialInputState();
        let questionId = "";
        if (this.props.conditionalLookup === true) {
            questionId = this.props.mainQuestionId
        } else {
            questionId = this.props.question.id
        }
        if (this.state.lookupObj && JSON.stringify(this.state.lookupObj) !== JSON.stringify(prevState.lookupObj)) {
            this.props.dispatch(setQuestionAnswer({ key: questionId + "-ssn", value: this.state.search }, this.props.customerId, this.props.offerType, this.props.subgroup, this.props.groupTitle))
            this.props.question.value.return_values.map((val, i) => {
                if (val === "name") {
                    this.props.dispatch(setQuestionAnswer({ key: questionId + "-" + val, value: this.state.lookupObj.Name }, this.props.customerId, this.props.offerType, this.props.subgroup, this.props.groupTitle))
                }
                if (val === "address") {
                    this.props.dispatch(setQuestionAnswer({ key: questionId + "-" + val, value: this.state.lookupObj.Address }, this.props.customerId, this.props.offerType, this.props.subgroup, this.props.groupTitle))
                }
                if (val === "postcode_city") {
                    this.props.dispatch(setQuestionAnswer({ key: questionId + "-" + val, value: this.state.lookupObj.Postcode + " " + this.state.lookupObj.City }, this.props.customerId, this.props.offerType, this.props.subgroup, this.props.groupTitle))
                }
                if (val === "nationality") {
                    this.props.dispatch(setQuestionAnswer({ key: questionId + "-" + val, value: this.state.lookupObj.NationalityId }, this.props.customerId, this.props.offerType, this.props.subgroup, this.props.groupTitle))
                }
                if (val === "birthplace") {
                    this.props.dispatch(setQuestionAnswer({ key: questionId + "-" + val, value: this.state.lookupObj.BirthplaceName }, this.props.customerId, this.props.offerType, this.props.subgroup, this.props.groupTitle))
                }
                
            })
        }
    }

    handleSSN(event) {

        this.setState({
            search: event.target.value
        })
        let onlyLookup = true;

        let age = calculateAgeFromKennitala(kennitala.clean(event.target.value))
        if (kennitala.isValid(event.target.value)) {
            if (age > 17) {
                this.setState({error: '', lookupObj: null})
                this.props.dispatch(fetchNationalRegistry(kennitala.clean(event.target.value), onlyLookup))
            } else {
                this.setState({error: 'Einstaklingur þarf að hafa náð 18 ára aldri við gerð samnings.', lookupObj: null})
            }
        }
        else {
            this.setState({error: '', lookupObj: null})
        }
    }

    getLookupQuestionValue(questionId, val){
        let questionValue = ""
        if (this.state.lookupObj) {
            if (val === "name") {
                questionValue = this.state.lookupObj.Name
            } else if (val === "address") {
                questionValue = this.state.lookupObj.Address
            } else if (val === "postcode_city") {
                questionValue = this.state.lookupObj.Postcode + ' ' + this.state.lookupObj.City
            } else if (val === "nationality") {
                questionValue = this.state.lookupObj.NationalityId
            } else if (val === "birthplace") {
                questionValue = this.state.lookupObj.BirthplaceName
            } else if (val === "ssn") {
                questionValue = this.state.search
            }
        } else if (this.props.healthQuestions && this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType]) {
            questionValue = this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId + "-" + val]
        }
        return questionValue
    }

    renderQuestionAnwers(question, questionId) {
        let allAnswers = question && question.value.return_values.map((val, i) => {
            if (val === "name" && (this.props.healthQuestions.data && this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId + "-name"] || this.state.lookupObj)) {
                return (
                    <div className={`qa${this.props.conditionalLookup ? ' conditional-input' : ''}`}>
                        <label className="question" htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + val}>Fullt nafn</label>
                        <input className="answer input" type="text" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + val} value={this.getLookupQuestionValue(questionId, val)} disabled></input>
                    </div>
                )
            }
            if (val === "address" && (this.props.healthQuestions.data && this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId + "-address"] || this.state.lookupObj)) {
                return (
                    <div className={`qa${this.props.conditionalLookup ? ' conditional-input' : ''}`}>
                        <label className="question" htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + val}>Heimilisfang</label>
                        <input className="answer input" type="text" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + val} value={this.getLookupQuestionValue(questionId, val)} disabled></input>
                    </div>
                )
            }
            if (val === "postcode_city" && (this.props.healthQuestions.data && this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId + "-postcode_city"] || this.state.lookupObj)) {
                return (
                    <div className={`qa${this.props.conditionalLookup ? ' conditional-input' : ''}`}>
                        <label className="question" htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + val}>Póstnúmer og staður</label>
                        <input className="answer input" type="text" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + val} value={this.getLookupQuestionValue(questionId, val)} disabled></input>
                    </div>
                )
            }
            if (val === "nationality" && (this.props.healthQuestions.data && this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId + "-nationality"] || this.state.lookupObj)) {
                return (
                    <div className={`qa${this.props.conditionalLookup ? ' conditional-input' : ''}`}>
                        <label className="question" htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + val}>Þjóðerni</label>
                        <input className="answer input" type="text" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + val} value={this.getLookupQuestionValue(questionId, val)} disabled></input>
                    </div>
                )
            }
            if (val === "birthplace" && (this.props.healthQuestions.data && this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType][questionId + "-birthplace"] || this.state.lookupObj)) {
                return (
                    <div className={`qa${this.props.conditionalLookup ? ' conditional-input' : ''}`}>
                        <label className="question" htmlFor={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + val}>Fæðingarstaður</label>
                        <input className="answer input" type="text" id={this.props.customerId + "-" + this.props.offerType + "-" + question.id + "-" + val} value={this.getLookupQuestionValue(questionId, val)} disabled></input>
                    </div>
                )
            }
        })
        return allAnswers;

    }

    render() {
        const { customerId, offerType, question } = this.props;
        let questionId = "";
        if (this.props.conditionalLookup === true) {
            questionId = this.props.mainQuestionId
        } else {
            questionId = this.props.question.id
        }

        return (
            <>
                {question.value.label !== "" && <div className="text-block ssn-lookup-label">{question.value.label}</div>}
                <div className={`qa${this.props.conditionalLookup ? ' conditional-input' : ''}`}>
                    <label className="question" htmlFor={customerId + "-" + offerType + "-" + questionId}>Kennitala</label>
                    <input className="answer input" type="text" id={customerId + "-" + offerType + "-" + questionId} onChange={this.handleSSN.bind(this)} autoFocus value={this.state.search}></input>
                    { this.state.error !== '' && <div className="error">{this.state.error}</div> }
                </div>
                {((this.state.lookupObj) ||( this.props.healthQuestions && this.props.healthQuestions.data && this.props.healthQuestions.data[this.props.customerId] && this.props.healthQuestions.data[this.props.customerId][this.props.offerType])) &&
                    this.renderQuestionAnwers(question, questionId)
                }
            </>
        )
    }
}

SsnLookup.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        nationalRegistry: {},
        healthQuestions: {},
    }

    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.healthQuestions = (state.healthQuestions === undefined) ? {} : state.healthQuestions

    return f;
}

export default connect(mapStateToProps)(SsnLookup);